/** IDs ERP (id_usuario / iderp) con acceso al portal vendedora en LMS móvil. */
export const ACCESO_PORTAL_RH_IDS = [334, 1, 32, 31, 568]

/** Puestos de vendedora (y equivalentes) con acceso al portal. */
export const ACCESO_PORTAL_RH_PUESTOS = [18, 78]

/**
 * Login tipo vendedora/RH: cualquier valor con @ (correo).
 * Matrícula numérica → LMS alumno.
 */
export function esCorreoRh (valor) {
  return String(valor || '').trim().indexOf('@') !== -1
}

/**
 * IDs posibles del login RH.
 * api-rh mezcla id_usuario/iderp (ERP) e idusuario (capa erp_nuevo); la whitelist usa ERP.
 */
export function idsUsuarioRh (row) {
  if (!row || typeof row !== 'object') return []
  const permiso = row.permiso && typeof row.permiso === 'object' ? row.permiso : null
  const rawList = [
    row.id_usuario,
    row.iderp,
    row.idusuario,
    row.id,
    permiso && permiso.id_usuario,
    permiso && permiso.iderp,
  ]
  const out = []
  for (const raw of rawList) {
    const id = Number(raw)
    if (Number.isFinite(id) && id > 0 && !out.includes(id)) out.push(id)
  }
  return out
}

/** Preferir id ERP (id_usuario / iderp) sobre idusuario de capa. */
export function idUsuarioRh (row) {
  const ids = idsUsuarioRh(row)
  return ids.length ? ids[0] : null
}

export function idPuestoRh (row) {
  if (!row || typeof row !== 'object') return null
  const raw = row.idpuesto ?? row.id_puesto
  const id = Number(raw)
  return Number.isFinite(id) ? id : null
}

/** true si el usuario RH puede entrar al módulo Twilio nativo del LMS móvil. */
export function puedeAccederPortalRh (row) {
  const ids = idsUsuarioRh(row)
  if (ids.some((id) => ACCESO_PORTAL_RH_IDS.includes(id))) return true
  const puesto = idPuestoRh(row)
  if (puesto != null && ACCESO_PORTAL_RH_PUESTOS.includes(puesto)) return true
  return false
}
